<app-screen-content>
  <div body>
    <div class="row">
      <div class="col-lg-4 offset-lg-2">
        <app-section-header class="header">Login</app-section-header>
      </div>
    </div>
    <div class="row content">
      <div class="col-lg-3 left-col offset-lg-2">
        <form id="form-login" [formGroup]="loginForm" (ngSubmit)="onSubmit()">
            <div class="field-wrapper">
                <label>
                  <span>Case ID</span>
                  <input
                    [class.invalid-input]="
                      isLoginFormSubmitted && caseIDControl.errors
                    "
                    type="text"
                    formControlName="caseID"
                    required
                  />
                </label>
                <!--      Value: {{ emailAddress.value }}-->
                <!--      Error: {{ emailAddress.errors | json }}-->
                <!--      Dirty: {{ emailAddress.dirty | json }}-->
    
                <span
                  class="error"
                  *ngIf="
                    isLoginFormSubmitted &&
                    caseIDControl.errors &&
                    caseIDControl.errors.required
                  "
                >
                  Please enter a valid case ID
                </span>
                <span class="error" *ngIf="isLoginFormSubmitted && isLoginFailed">
                  {{login_fail_message}}
                </span>
               
              </div>
          <div class="field-wrapper">
            <label>
              <span>Email address</span>
              <input
                [class.invalid-input]="
                  isLoginFormSubmitted && emailAddressControl.errors
                "
                type="text"
                formControlName="emailAddress"
                required
              />
            </label>
            <!--      Value: {{ emailAddress.value }}-->
            <!--      Error: {{ emailAddress.errors | json }}-->
            <!--      Dirty: {{ emailAddress.dirty | json }}-->

            <span
              class="error"
              *ngIf="
                isLoginFormSubmitted &&
                emailAddressControl.errors &&
                emailAddressControl.errors.required
              "
            >
              Please enter a valid email address
            </span>
            <span
              class="error"
              *ngIf="
                isLoginFormSubmitted &&
                emailAddressControl.errors &&
                emailAddressControl.errors.email
              "
            >
              Please enter a valid email address
            </span>
          </div>
          <div class="field-wrapper">
            <label>
              <span>Password</span>
              <input
                [class.invalid-input]="
                  isLoginFormSubmitted && passwordControl.errors
                "
                type="password"
                formControlName="password"
                required
              />
            </label>
            <span
              class="error"
              *ngIf="isLoginFormSubmitted && passwordControl.errors"
            >
              Please enter a valid password
            </span>

            

            <!--Value: {{ password.value }}-->
            <!--Error: {{ password.errors  | json  }}-->
            <!--            <label-->
            <!--              class="error"-->
            <!--              *ngIf="-->
            <!--                passwordControl.dirty &&-->
            <!--                passwordControl.errors &&-->
            <!--                passwordControl.errors.required-->
            <!--              "-->
            <!--            >-->
            <!--              Password is required.-->
            <!--            </label>-->
          </div>
          
          <div class="blue-link fna-mt-10" (click)="openForgotPasswordFormModal()">
            Forgot password?
          </div>
          <div class="login-btn-wrapper">
            <div class="row">
              <div class="col-lg-8">
                <app-primary-button buttonType="submit" [block]="true"
                  >Login</app-primary-button
                >
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-lg-1"></div>
      <div class="divider"><div class="text-or">OR</div></div>
      <div class="col-lg-3 right-col offset-lg-1">
        <div class="buttons">
            <form id="form-login-bv" [formGroup]="loginFormBV" >
                <div class="field-wrapper">
                    <label>
                      <span>Case ID</span>
                      <input
                       
                        type="text"
                        formControlName="caseID"
                        required
                      />
                    </label>
                  
                  
                   
                  </div>
            </form>
            
          <app-red-button
            [block]="true"
            (click)="handleClickOCBCVelocityLogIn()"
            [disabled] = "!loginFormBV.valid"
          >
            Login with OCBC Velocity
          </app-red-button>
        </div>
      </div>
    </div>
  </div>
</app-screen-content>
